import React from "react";
import { Route } from "react-router-dom";
import Page from "@ROM-pages/CompanyAdmin/Customers/Edit";
import Layout from "@ROM-pages/Layouts/CompanyAdmin";

class RouteHandler extends Route {
  render() {
    return (
      <Layout>
        <Page customerId={this.props.computedMatch.params.customerId} tab={this.props.computedMatch.params.tab} />
      </Layout>
    );
  }
}

export default RouteHandler;
